<template>
    <div id="headerDiv">
        <div class="loading">
            <div class="loading-img">
                <img src="static/images/walk.gif" alt="">
            </div>
        </div>
        <header>
            <div class="container" v-if="!(step)">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="logo">
                            <router-link to="/"><img src="static/images/logo-svg.svg" class="img-fluid" alt=""></router-link>
                        </div>
                        <!-- <div class="header-contact">
                            <h6>Call us at</h6>
                            <h5><a href="tel:+919025662566">+91 90256 62566</a></h5>
                        </div> -->
                    </div>
                    <div class="col-sm-6">
                        <ul class="text-center top-menu float-sm-right">
                            <li v-if="profile">
                                <div class="book-tr" v-on:click="goToProfile()">
                                    <h4 class="your-credit-header-1"><b>Your Credit</b> </h4>
                                    <h3 class="your-credit-header-2">Rs {{profile.credits}} </h3>
                                </div>
                            </li>
                            <li v-if="$route.fullPath === '/' || $route.fullPath === '/login'">
                              <router-link to="/lab">
                                  <span class="sprites sprite-flask"></span>Book Test
                              </router-link>
                            </li>
                            <li v-if="!(profile) || profile === false || profile === null">
                                <a href="#" data-toggle="modal" data-target=".login-box" @click="loginClicked()" data-backdrop="static" data-keyboard="false">
                                    <span class="sprites sprite-login"></span>
                                    Login/ Sign Up
                                </a>
                            </li>
                            <li v-else>
                                <!--<a href="#" data-toggle="modal" data-target=".login-box" @click="loginClicked()" data-backdrop="static" data-keyboard="false">
                                    <span class="sprites sprite-login"></span>
                                    Login/ Sign Up
                                </a>-->
                                <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span class="sprites sprite-login" ></span>
                                   <span class="text-eclipse"> Hi, {{profile.firstName}}</span>
                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                      <router-link to="/myprofile" class="dropdown-item">My Profile</router-link>
                                      <router-link to="/referral/invite" class="dropdown-item">Refer & Earn</router-link>
                                      <router-link to="/myresult" class="dropdown-item">My Result</router-link>
                                      <a class="dropdown-item red" v-on:click="logout()">Log Out</a>
                                  </div>
                                </a>
                            </li>
                            <li class="dropdown" v-if="cartCount <= 0 && !isHealthCartEnabled">
                                <router-link to="/lab" id="dropdownMenu2" data-toggle="dropdown" >
                                    <span>
                                        <span class="sprites sprite-care"></span>
                                        <span>Health Cart</span>
                                        <span v-if="cartCount > 0" class="count-cart">{{cartCount}}</span>
                                    </span>
                                </router-link>
                            </li>
                            <li class="dropdown" id="HealthCartDropDownClicks" v-if="cartCount > 0 && !isHealthCartEnabled">
                                <a id="dropdownMenu2" v-on:click="openHealthCart()" >
                                   <span>
                                        <span class="sprites sprite-care"></span>
                                        <span>Health Cart</span>
                                        <span v-if="cartCount > 0" class="count-cart">{{cartCount}}</span>
                                    </span>
                                    
                                </a>
                                <div class="dropdown-menu dropdown-menu-right caret-up top-cart p-0 healthCartDropdown" v-bind:class="cartDispaly ? 'show' : ''" aria-labelledby="dropdownMenu2">
                                    <div v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0">
                                        <!--<div v-if="selectedDatetime && selectedDatetime.time.startTimeDisp && selectedDatetime.time.endTimeDisp" class="alert alert-success mb-0 drop-shadow">
                                            28 / 10 / 2017 between 12:30 to 01:00 pm
                                            {{formatDate(selectedDatetime.date,'dd/mm/yyyy')}}{{' between '+ selectedDatetime.time.startTimeDisp +' to '+selectedDatetime.time.endTimeDisp}}
                                            (<a class="text-uppercase" href="">Change Date</a>)
                                        </div>
                                        <div v-else>-->
                                        <div v-if="lab && testCosts">
                                            <div v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0" class="alert alert-success mb-0 drop-shadow">
                                                Test(s) and/or Panel(s) and Lab added to health cart
                                            </div>
                                        </div>
                                        <!--</div>-->
                                        
                                        <div v-if="lab && testCosts" class="lab display-flex no-border p-3 mt-2 mb-0">
                                            <div class="flex-box">
                                                <div class="lab-logo">
                                                    <img v-if="lab.logo && lab.logo.length > 0" :src="lab.logo" />
                                                </div>
                                            </div>
                                            <div class="flex-box">
                                                <h6 class="black-color">{{ lab.labName }}</h6>
                                                <p class="mt-0 mb-1 grey-color">{{lab.branch.branchLocation+', '+lab.branch.branchCity+' - '+lab.branch.branchZipCode}}</p>
                                                <router-link to="/lab" class="text-uppercase mt-2 blue-color">Change Lab</router-link>
                                            </div>
                                        </div>
                                        <div v-if="lab && testCosts && testCosts.priceDetails && testCosts.priceDetails.length > 0" class="table-responsive test-conformation p-3">
                                            <table class="table">
                                                <!-- <thead>
                                                    <tr>
                                                        <th class="no-border">Test Name</th>
                                                        <th class="text-center no-border" colspan="2">&nbsp;&nbsp;&nbsp;&nbsp;Price</th>
                                                        <th class="no-border"></th>
                                                    </tr>
                                                </thead> -->
                                                <tbody class="black-color health-cart">
                                                    <tr v-for="(testProfile, index) in testCosts.priceDetails" :key="index">
                                                        <td>{{testProfile.aliasName}}</td>
                                                        <td class="text-right">
                                                            <h5 class="float-right mt-1 mb-0 price-tags ">
                                                                <span class="red-color strip-text" v-if='parseInt(testProfile.actualPrice) > parseInt(testProfile.ourPrice)'>Rs. {{testProfile.actualPrice}}</span>
                                                            </h5>
                                                        </td>
                                                        <td class="text-right ">
                                                            <h5 class="float-right mt-1 mb-0 price-tags ">
                                                                Rs. {{testProfile.ourPrice}}
                                                            </h5>
                                                        </td>
                                                        <td>
                                                            <button class="btn btn-link remove-btn p-0" @click.prevent="removeSelectedItemsInLab(testProfile)">
                                                                <img :src="closeImg" alt="">
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot class="border-bottom">
                                                    <tr>
                                                        <td class="grey-color" colspan="2">Sub Total</td>
                                                        <!-- <td class="text-right">
                                                            <span class="red-color strip-text" v-if="parseInt(testCosts.mrp) > parseInt(testCosts.ourPrice)">Rs.{{testCosts.mrp}}</span>
                                                        </td> -->
                                                         <td class="text-right">
                                                             <h5 class="float-right mt-1 mb-0 price-tags ">
                                                                Rs. {{testCosts.ourPrice}}
                                                            </h5>
                                                            <!--Rs. {{testCosts.ourPrice}}-->
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                        <div v-if="!lab && selectedProfileAndTest">
                                            <div v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0" class="alert alert-success mb-0 drop-shadow">
                                                <strong><i class="material-icons float-left mr-2">check</i></strong> Test(s) and/or Panel(s) added to health cart
                                            </div>
                                        </div>
                                        <div id="healthCartTestTable" v-if="!lab && selectedProfileAndTest" class="table-responsive test-conformation p-3">
                                            <table class="table">
                                                <tbody class="black-color">
                                                    <tr class="border-bottom" v-for="(testProfile, index) in selectedProfileAndTest" :key="index">
                                                        <td class="text-left">{{testProfile.name}}</td>
                                                        <!--<td>
                                                            <span class="red-color strip-text">Rs. 8000</span> Rs. 2199
                                                        </td>-->
                                                        <td class="text-right">
                                                            <button class="btn btn-link remove-btn p-0" @click.prevent="removeSelectedItems(testProfile)">
                                                                <img :src="closeImg" alt="">
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="row p-0 m-0 mb-3">
                                            <div class="col-sm-3"></div>
                                            <div class="col-sm-3">
                                                <router-link to="/lab"><button class="btn btn-link full-width text-uppercase">Add Test</button></router-link>
                                            </div>
                                            <div class="col-sm-6" v-if="!lab">
                                                <router-link to="/lab"><button class="btn btn-primary full-width text-uppercase">Select Lab</button></router-link>
                                            </div>
                                            <!--&& (!selectedDatetime || !selectedDatetime.time.startTimeDisp || !selectedDatetime.time.endTimeDisp)-->
                                            <div class="col-sm-6" v-if="lab">
                                                <button class="btn btn-primary full-width text-uppercase" @click="proccedtoHealthCart()">Proceed to health cart</button>
                                            </div>
                                            <!--<div class="col-sm-6" v-if="lab && selectedDatetime && selectedDatetime.time.startTimeDisp && selectedDatetime.time.endTimeDisp">
                                                <router-link to="/address"><button class="btn btn-primary full-width text-uppercase">Proceed to checkout</button></router-link>
                                            </div>-->
                                        </div>
                                    </div>
                                    <!--<div v-if="!selectedProfileAndTest || selectedProfileAndTest.length == 0">
                                        Cart is empty
                                        <div class="col-sm-6" v-if="!locality">
                                            <router-link to="/" class="btn btn-outline-primary full-width">Add Locality</router-link>
                                        </div>
                                        <div class="col-sm-6" v-if="locality">
                                            <router-link to="/test" class="btn btn-outline-primary full-width">Add Test</router-link>
                                        </div>
                                    </div>-->
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="container" v-if="(step)">
                <div class="row">
                    <div class="col-sm-5">
                        <div class="logo">
                            <router-link to="/"><img src="static/images/logo-svg.svg" class="img-fluid" alt=""></router-link>
                        </div>
                        <!-- <div class="header-contact">
                            <h6>Call us at</h6>
                            <h5><a href="tel:+919025662566">+91 90256 62566</a></h5>
                        </div> -->
                    </div>
                    <div class="col-sm-5">
                        <ul class="stepper">
                            <li v-bind:class="{'active': (tab=='health')}">
                                Health Cart
                            </li>
                            <li>
                                <i class="material-icons grey-color">keyboard_arrow_right</i>
                            </li>
                            <li v-bind:class="{'active': (tab=='patient')}">
                                Patient Details & Pay
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-2">
                        <a class="float-right mt-4 user-text" href="#" v-if="!profile || profile === 'false' || profile === null" data-toggle="modal" data-target=".login-box" @click="loginClicked()" data-backdrop="static" data-keyboard="false">Login/ Sign Up</a>
                        <div class="dropdown" v-else>
                            <a href="#" class="float-right mt-4 user-text dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">Hi, {{profile.firstName}}</a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                <router-link to="/myprofile" class="dropdown-item">My Profile</router-link>
                                <router-link to="/myprofile" class="dropdown-item">Refer & Earn</router-link>
                                <router-link to="/myresult" class="dropdown-item">My Result</router-link>
                                <a class="dropdown-item red" v-on:click="logout()">Log Out</a>
                            </div>
                        </div>
                    </div>
                     <!-- <div class="col-sm-3">
                        <a class="float-right mt-4 user-text" href="#" v-if="$cookie.get('loggedIn') === 'false' || $cookie.get('loggedIn') === null" data-toggle="modal" data-target=".login-box" data-backdrop="static" data-keyboard="false">Login/ Sign Up</a>
                        <div class="dropdown" v-else>
                            <a href="#" class="float-right mt-4 user-text dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">Hi, {{loggedin_username}}</a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                <router-link to="/myprofile" class="dropdown-item">My Profile</router-link>
                                <router-link to="/myresult" class="dropdown-item">My Result</router-link>
                                <a class="dropdown-item red" v-on:click="logout()">Log Out</a>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
            <Login />
        </header>
    </div>
</template>

<script>
import Login from '@/components/web/Login'
import closeImg from '../../../static/images/close-black.svg'
import _ from 'underscore'
import dateFormat from 'dateformat'
import $ from 'jquery'
import Vue from 'vue'

export default {
  name: 'HeaderVue',
  props: ['step', 'tab', 'isHealthCartEnabled'],
  components: {
    Login
  },
  data () {
    return {
      loggedin_username: '',
      locality: undefined,
      lab: undefined,
      selectedProfileAndTest: undefined,
      selectedDatetime: undefined,
      closeImg: closeImg,
      testCosts: [],
      cartCount: 0,
      payinfo: {},
      profile: undefined,
      cartDispaly: false
    }
  },
  mounted: function () {
    this.$root.$on('selectedProfileAndTest', (selectedProfileAndTest) => {
      this.selectedProfileAndTest = selectedProfileAndTest
      this.cartCount = selectedProfileAndTest.length
      this.refreshContent()
    })
    this.$root.$on('profileUpdated', (profileUpdateStatus) => {
      this.profile = this.$localStorage.get('profile')
    })
    this.$root.$on('bookTest', (bookTest) => {
      location.reload()
    })
    this.$root.$on('isLogin', (isLoggin) => {
      this.refreshContent()
    })
    $('body').click(function (e) {
      if (e.target.id === 'HealthCartDropDownClicks' || $(e.target).parents('#HealthCartDropDownClicks').length) {
        this.cartDispaly = true
      } else {
        this.cartDispaly = false
      }
    }.bind(this))
  },
  created () {
    if (this.$route.fullPath === '/login') {
    //   this.$localStorage.remove('profile')
    }
    if (this.$localStorage.get('profile')) {
      this.loggedin_username = this.$localStorage.get('profile').username
    }
    this.locality = this.$localStorage.get('location')
    this.lab = this.$localStorage.get('sl')
    this.selectedProfileAndTest = this.$localStorage.get('st')
    this.selectedDatetime = this.$localStorage.get('ct')
    this.profile = this.$localStorage.get('profile')
    this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0
    if (this.lab) {
      this.getTestCosts()
    }
    if (this.$route.fullPath !== '/' && this.$route.fullPath !== '/login') {
      setTimeout(function () {
        var footerHeight = $('#footerDiv').outerHeight()
        $('body').css('margin-bottom', footerHeight)
      }, 100)
    }
  },
  methods: {
    goToProfile: function () {
        this.$router.push('/myprofile')
    },
    loginClicked: function () {
      Vue.analytics.fbq.event('ViewContent', {
        content_ids: 0,
        content_name: 'LOGIN CLICKED',
        contents: '',
        content_type: 'LOGIN_CLICK'
      })
      this.$root.$emit('loginClicked', true)
    },
    proccedtoHealthCart: function () {
      this.$localStorage.remove('ct')
      this.$localStorage.remove('sa')
      this.$localStorage.remove('sm')
      this.$localStorage.remove('cou')
      this.$router.push('/appointment')
    },
    openHealthCart: function () {
      this.cartDispaly = true
    },
    logout: function () {
      this.profile = undefined
      this.$clearLocalStorageForLogout()
    //   this.$clientTokenForLogout()
      setTimeout(function () {
        this.refreshContent()
        location.reload()
      }.bind(this), 300)
    },
    getTestCosts: function (lab) {
      try {
        let labTestCosts = []
        if (this.lab) {
          if ((this.lab.labTestList).length > 0) {
            _.each(this.lab.labTestList, function (element) {
              labTestCosts.push(element.labProfileId)
            })
          }
        }
        if (labTestCosts.length === 0) {
        //   this.$router.push('/test')
          this.$router.push('/lab')
        }
        let data = {
          'labId': (this.lab) ? this.lab.labId : '0',
          'labTests': labTestCosts
        }
        Promise.resolve(this.$POST('patient/getTestCosts', data)).then(function (res) {
          if (res.response_code === 0) {
            if (res.response) {
              this.testCosts = res.response
              this.payinfo.mrpTotal = res.response.mrp
              this.payinfo.phlebotomistFee = this.$phlebotomistFee
              this.payinfo.subTotal = (this.payinfo.mrpTotal + this.payinfo.phlebotomistFee)
              this.payinfo.labDiscount = res.response.youSaved
              this.payinfo.phlebotomyFeeWaiver = ((this.payinfo.mrpTotal - this.payinfo.labDiscount) > this.$waiverDiscountApplyFee) ? this.$phlebotomyFeeWaiver : 0
              this.payinfo.total = this.payinfo.subTotal - (this.payinfo.labDiscount + this.payinfo.phlebotomyFeeWaiver)
              this.payinfo.gst = Math.round(((this.payinfo.total) * this.$GSTFee) / 100)
              this.payinfo.grandTotal = (this.payinfo.total + this.payinfo.gst)
            }
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.log(e)
      }
    },
    removeSelectedItems: function (items) {
      this.$localStorage.remove('st')
      this.$localStorage.remove('cou')
      var index = this.selectedProfileAndTest.indexOf(items)
      this.selectedProfileAndTest.splice(index, 1)
      this.$localStorage.set('st', this.selectedProfileAndTest, 0)
      this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0
      if (this.selectedProfileAndTest.length === 0) {
        this.$localStorage.remove('sl')
        this.$localStorage.remove('ct')
        this.lab = undefined
        this.testCosts = []
        // this.$router.push('/test')
        this.$router.push('/lab')
      }
      this.$root.$emit('removeProfileAndTest', this.selectedProfileAndTest)
    },
    removeSelectedItemsInLab: function (items) {
      this.$localStorage.remove('cou')
      this.$localStorage.remove('st')
      this.$localStorage.remove('ct')
      let tests = {}
      this.selectedProfileAndTest.forEach(function (item) {
        if ((items.testId === item.testId && item.testId !== 0) || (items.panelId === item.panelId && item.panelId !== 0)) {
          tests = item
        }
      })
      let labTests = []
      this.lab.labTestList.forEach(function (labTest) {
        if (!((items.testId === labTest.testId && labTest.testId !== 0) || (items.panelId === labTest.panelId && labTest.panelId !== 0))) {
          labTests.push(labTest)
        }
      })
      this.$localStorage.remove('sl')
      this.lab.labTestList = labTests
      this.$localStorage.set('sl', this.lab, 30 * 60 * 1000)
      this.selectedDatetime = undefined
      var index = this.selectedProfileAndTest.indexOf(tests)
      this.selectedProfileAndTest.splice(index, 1)
      this.$localStorage.set('st', this.selectedProfileAndTest, 0)
      this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0
      if (this.selectedProfileAndTest.length === 0) {
        this.$localStorage.remove('sl')
        this.$localStorage.remove('ct')
        this.lab = undefined
        this.testCosts = []
        // this.$router.push('/test')
        this.$router.push('/lab')
      }
      this.$root.$emit('removeProfileAndTest', this.selectedProfileAndTest)
      this.getTestCosts()
    },
    refreshContent: function () {
      this.profile = this.$localStorage.get('profile')
      this.locality = this.$localStorage.get('location')
      this.lab = this.$localStorage.get('sl')
      this.selectedProfileAndTest = this.$localStorage.get('st')
      this.selectedDatetime = this.$localStorage.get('ct')
      this.cartCount = this.selectedProfileAndTest ? this.selectedProfileAndTest.length : 0
      if (this.lab) {
        this.getTestCosts()
      }
    },
    formatDate: function (date, format) {
      return dateFormat(date, format, true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/Header.vue